var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 41,
    viewBox: "0 0 90 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6431 21.4741L18.4225 21.5296L16.9798 23.0832L18.0895 25.802L13.3178 27.0227L12.8739 28.9647L13.9836 30.5738L12.8739 32.1828L7.88019 29.797L6.715 29.8524L4.82849 32.1828L5.60529 33.5145L4.93946 38.6746L4.05169 39.3959L3.10844 38.4527L1 40.3947L18.0895 40.2282L17.8676 37.7314H20.3644L21.1412 38.2308L69.802 38.6191L75.8499 36.6217L76.1274 35.29L78.3468 34.8461L80.7881 31.0176L85.116 28.9647L89 25.2471L85.6709 23.0277L81.9533 16.0366V11.3203L79.2346 9.37829L78.5132 6.82596L74.6293 9.15635L71.855 7.88018L68.3594 8.76795L67.6381 6.99242L63.6986 6.2711L60.2585 1.61032L58.261 1.99872L56.652 1L55.3203 2.27617L55.7087 6.32658L48.6066 7.54729L48.773 10.1551L45.6658 13.7617L43.7793 14.261L43.169 18.0341L39.7844 17.8676L38.5082 15.6482L36.1223 17.1463L36.1778 19.0328L34.8462 20.3645L32.6267 18.2005L30.0189 19.4211L29.3531 21.1967L26.4679 19.4211L23.3607 18.9773L22.9168 20.7529L21.8626 19.7541L19.6986 19.5876L19.6431 21.4741Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKy);
export default __webpack_public_path__ + "static/media/KY.a0407dbeb66efd6c54e69616ea4cab99.svg";
export { ForwardRef as ReactComponent };